import { Injectable } from '@angular/core';
import {connectApi} from "./connect-api";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs/internal/Observable";
import {CustomHttpParams} from './connect-http-interceptor';


// This a sharable service used for ID generation.
@Injectable()
export class IDService {

    constructor(private http: HttpClient) {
    }

    /**
     *
     * @param {number} count - number of IDs to request
     * @returns {Observable<number[]>} IDs returned from backend
     */
    getIDsFromServer(count: number) : Observable<number[]>  {
        let url : string = `${connectApi.ids}?count=${count}`;

        return this.http.get(url, {params: new CustomHttpParams(true)})
            .pipe(map((res : Response) => {
                let newIDs: number[] = res["GUIDs"];
                return newIDs;
            }))
            ;
    }
}
